import React from 'react';
import './saleConfirm.scss';

class NumSelector extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      num: 1,
    };
  }
  increase() {
    if (this.state.num === this.props.total) {
      return;
    }
    this.setState((state) => {
      this.props.handleSelect(state.num + 1);
      return {
        num: state.num + 1,
      };
    });
  }
  decrease() {
    if (this.state.num === 1) {
      return;
    }
    this.setState((state) => {
      this.props.handleSelect(state.num - 1);
      return {
        num: state.num - 1,
      };
    });
  }
  render() {
    return (
      <div className='numSelector'>
        <span className="title"><span className='label-name'>核销份数</span><span>:</span></span>
          <div className="quantity">
            {/* <i className='quantity-decrease' onClick={() => this.decrease()}></i> */}
            {/*<input disabled='disabled' value={this.state.num}/>份*/}
            {/* <i className="quantity-increase" onClick={() => this.increase()}></i> */}
            <span>{this.props.unverifyText}</span>
          </div>
      </div>)
  }
}
export default NumSelector;
